import TextToolTip from "@lhd/components/TextToolTip";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { ReactNode } from "react";
import {
  HIDDEN_FILTER_APP_PART_TYPES,
  HIDDEN_TITLE_APP_PART_TYPES,
  TITLE_MIN_HEIGHT,
} from "../../constants";

interface IProps {
  item: AppPartType;
  filterIcon?: ReactNode;
  isLabelVisible?: boolean;
}

const Title = (props: IProps) => {
  const { item, filterIcon, isLabelVisible } = props;
  if (
    HIDDEN_TITLE_APP_PART_TYPES.includes(
      item.app_part_type as typeof HIDDEN_TITLE_APP_PART_TYPES[number],
    )
  ) {
    return <div></div>;
  }
  const isDev = localStorage.getItem("isDev") === "true"; // just for dev
  const label = isDev
    ? item.id + "_" + item.app_part_type
    : item.label_text || item.name;
  return (
    <div
      style={{
        display: "flex",
        minHeight: TITLE_MIN_HEIGHT,
        justifyContent: "space-between",
      }}
    >
      <div style={{ display: "flex" }}>
        <TextToolTip>
          {item.is_hide_name && !isLabelVisible ? "" : label}
        </TextToolTip>
        {item.is_required_field && <span className="required-star">*</span>}
      </div>
      {!HIDDEN_FILTER_APP_PART_TYPES.includes(item.app_part_type as any) &&
        filterIcon}
    </div>
  );
};

export default Title;
